import React, { Component } from 'react';
import { Form, Input, Radio } from 'antd';
import { get } from 'lodash';
import { language } from '../../../language';
import {
    ColorPicker,
    FormItemLayout,
    ConfigFormDecorator,
    NumberInput,
    EffectiveTime,
} from '../../tools';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

/**
 * 标题组件-配置表单
 */
class title extends Component<any> {
    effectiveTimeChange = (value: any) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();
        const { effectiveTime } = value;
        onChange({ ...formValue, effectiveTime });
    };

    render() {
        const {
            form: { getFieldDecorator },
            value,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="title-form">
                <FormItem {...formItemLayout} label={'标题内容'}>
                    {getFieldDecorator('title', {
                        rules: [
                            {
                                required: true,
                                message: language.getText('components.Title.contentRequired'),
                            },
                        ],
                    })(<Input />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Title.color')}>
                    {getFieldDecorator('fontColor')(<ColorPicker />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Title.size')}>
                    {getFieldDecorator('fontSize')(<NumberInput min={10} />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Title.align')}>
                    {getFieldDecorator('align')(
                        <RadioGroup className="align-style">
                            <Radio value={'left'}>
                                {language.getText('components.Title.left')}
                            </Radio>
                            <Radio value={'center'}>
                                {language.getText('components.Title.center')}
                            </Radio>
                            <Radio value={'right'}>
                                {language.getText('components.Title.right')}
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <div style={{ marginLeft: 24 }}>
                    <EffectiveTime
                        value={{ effectiveTime: get(value, 'effectiveTime', null) }}
                        onChange={this.effectiveTimeChange}
                    />
                </div>
            </Form>
        );
    }
}

export const Title = ConfigFormDecorator(title);
